module.exports = __webpack_public_path__ + "img/bbgg.985bac22.jpg";